import { render, staticRenderFns } from "./SignInAzureAdPage.vue?vue&type=template&id=19d053b6&scoped=true"
import script from "./SignInAzureAdPage.vue?vue&type=script&lang=ts"
export * from "./SignInAzureAdPage.vue?vue&type=script&lang=ts"
import style0 from "./SignInAzureAdPage.vue?vue&type=style&index=0&id=19d053b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d053b6",
  null
  
)

export default component.exports